module.exports = __webpack_public_path__ + "static/media/transaction-list_viejo.10a55b45.svg";